(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["redolia-gift-picker"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.getElementById('rdl-gift');
  if (!root) return;
  var VARIANT = parseInt(root.dataset.variant, 10);
  var HANDLE = root.dataset.handle;
  var TIERS = [[30000, 4], [20000, 2], [12000, 1]]; // cents -> samples
  var catalog = null, cart = null, busy = false;

  function money(c) { return '$' + (c / 100).toFixed(0); }

  function allowedFor(sub) {
    for (var i = 0; i < TIERS.length; i++) if (sub >= TIERS[i][0]) return TIERS[i][1];
    return 0;
  }
  function nextTier(sub) {
    var up = null;
    for (var i = 0; i < TIERS.length; i++) if (sub < TIERS[i][0]) up = TIERS[i];
    return up;
  }

  function loadCatalog() {
    if (catalog) return Promise.resolve(catalog);
    return Promise.all([1, 2].map(function (p) {
      return fetch('/products.json?limit=250&page=' + p).then(function (r) { return r.json(); }).catch(function () { return { products: [] }; });
    })).then(function (pages) {
      catalog = [];
      pages.forEach(function (pg) {
        (pg.products || []).forEach(function (p) {
          if (p.handle === HANDLE) return;
          var price = p.variants && p.variants[0] ? parseFloat(p.variants[0].price) : 0;
          if (price <= 0) return;
          catalog.push({ t: p.title, v: p.vendor, img: p.images && p.images[0] ? p.images[0].src.replace(/(\.[a-z]+)(\?|$)/, '_240x240$1$2') : '' });
        });
      });
      return catalog;
    });
  }

  function giftLines() {
    return (cart.items || []).map(function (it, idx) { it._line = idx + 1; return it; })
      .filter(function (it) { return it.handle === HANDLE; });
  }

  function render() {
    var gifts = giftLines();
    var count = gifts.reduce(function (s, g) { return s + g.quantity; }, 0);
    var sub = cart.items_subtotal_price;
    var allowed = allowedFor(sub);
    var title = document.getElementById('rdl-gift-title');
    var subEl = document.getElementById('rdl-gift-sub');
    var pick = document.getElementById('rdl-gift-pick');
    var chosen = document.getElementById('rdl-gift-chosen');
    var fill = document.getElementById('rdl-gift-bar-fill');

    if (!cart.items.length || (cart.items.length === gifts.length && !allowed)) { root.hidden = true; return; }
    root.hidden = false;

    var up = nextTier(sub);
    fill.style.width = Math.min(100, Math.round(sub / 300)) + '%';

    if (allowed === 0) {
      title.textContent = 'Complimentary discovery samples';
      subEl.textContent = 'Spend ' + money(12000) + ' and choose any 2 ml sample on us — ' + money(12000 - sub) + ' to go. ' + money(20000) + ' unlocks two, ' + money(30000) + ' unlocks four.';
      pick.hidden = true; chosen.innerHTML = ''; return;
    }

    chosen.innerHTML = gifts.map(function (g) {
      var f = (g.properties && g.properties.Fragrance) || '2 ml sample';
      return '<span class="rdl-gift__chip">' + f + ' · 2 ml <button data-line="' + g._line + '" aria-label="Remove">×</button></span>';
    }).join('');
    chosen.querySelectorAll('button').forEach(function (b) {
      b.onclick = function () { changeLine(parseInt(b.dataset.line, 10), 0); };
    });

    if (count < allowed) {
      title.textContent = 'Choose ' + (allowed - count) + ' complimentary 2 ml sample' + (allowed - count > 1 ? 's' : '');
      subEl.textContent = 'Your order unlocked ' + allowed + ' free sample' + (allowed > 1 ? 's' : '') + ' — any fragrance in the house.' + (up ? ' (' + money(up[0] - sub) + ' more unlocks ' + up[1] + '.)' : '');
      pick.hidden = false;
      loadCatalog().then(function () { search(document.getElementById('rdl-gift-search').value); });
    } else {
      title.textContent = 'Your ' + allowed + ' complimentary sample' + (allowed > 1 ? 's are' : ' is') + ' in the cart ✓';
      subEl.textContent = up ? money(up[0] - sub) + ' more unlocks ' + up[1] + ' samples.' : 'Enjoy — they ship with your order.';
      pick.hidden = true;
    }
  }

  function search(q) {
    q = (q || '').toLowerCase().trim();
    var res = catalog.filter(function (p) { return !q || (p.t + ' ' + p.v).toLowerCase().indexOf(q) !== -1; }).slice(0, 60);
    document.getElementById('rdl-gift-results').innerHTML = res.map(function (p, i) {
      return '<div class="rdl-gift__card" data-i="' + catalog.indexOf(p) + '">' + (p.img ? '<img loading="lazy" src="' + p.img + '" alt="">' : '') + '<b>' + p.t + '</b><i>' + p.v + '</i></div>';
    }).join('');
    document.getElementById('rdl-gift-results').querySelectorAll('.rdl-gift__card').forEach(function (c) {
      c.onclick = function () { addGift(catalog[parseInt(c.dataset.i, 10)].t); };
    });
  }

  function addGift(titleTxt) {
    if (busy) return; busy = true;
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: VARIANT, quantity: 1, properties: { Fragrance: titleTxt } })
    }).then(function () { location.reload(); });
  }

  function changeLine(line, qty) {
    if (busy) return; busy = true;
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function () { location.reload(); });
  }

  function enforce() {
    var gifts = giftLines();
    var count = gifts.reduce(function (s, g) { return s + g.quantity; }, 0);
    var allowed = allowedFor(cart.items_subtotal_price);
    if (count > allowed && gifts.length) {
      var last = gifts[gifts.length - 1];
      changeLine(last._line, Math.max(0, last.quantity - (count - allowed)));
      return true;
    }
    return false;
  }

  function refresh() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      cart = c;
      if (!enforce()) render();
    });
  }

  document.getElementById('rdl-gift-search').addEventListener('input', function (e) { search(e.target.value); });
  refresh();
  setInterval(function () { if (!busy) refresh(); }, 4000);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["redolia-shelf-mode"] && !Shopify.designMode) return;
  try {
    
(function () {
  var el = document.getElementById('rdl-shelf');
  if (!el) return;
  var qs = new URLSearchParams(location.search);
  if (qs.get('qr') !== 'shelf') return;
  el.hidden = false;
  var API = 'https://157-245-254-96.sslip.io';
  var handle = el.dataset.handle, title = el.dataset.title, url = el.dataset.url;
  function track(e, extra) {
    try { fetch(API + '/t', { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify({ e: e, p: handle, s: 'shelf', el: extra || '', h: location.pathname, vw: innerWidth }), keepalive: true }); } catch (x) {}
  }
  track('qr_scan');
  // lock-aware buy button: the theme hides buy buttons while ordering is closed
  var locked = !!document.getElementById('rdl-prelaunch-quickadd');
  if (locked && document.getElementById('rdl-shelf-buy')) { document.getElementById('rdl-shelf-buy').hidden = true; document.getElementById('rdl-shelf-buy-locked').hidden = false; }

  // drydown timer
  var start = null, iv = null;
  var top = el.dataset.top, heart = el.dataset.heart, base = el.dataset.base;
  var key = 'rdl-shelf-start:' + handle;
  try { start = parseInt(sessionStorage.getItem(key) || '0', 10) || null; } catch (e) {}
  function phase(mins) { return mins < 10 ? 'top' : mins < 60 ? 'heart' : 'base'; }
  function render() {
    var s = Math.floor((Date.now() - start) / 1000), m = Math.floor(s / 60);
    document.getElementById('rdl-shelf-clock').textContent = m + ':' + ('0' + (s % 60)).slice(-2);
    var ph = phase(m);
    var names = { top: 'Opening — top notes', heart: 'The heart', base: 'The drydown — base notes' };
    var texts = {
      top: 'Right now you are smelling the opening: ' + (top || 'the brightest, most volatile notes') + '. This is the loudest the fragrance will ever be — it fades within ten minutes.',
      heart: 'The top has burned off. What is left is the heart: ' + (heart || 'the main accord') + '. This is what people around you will notice for the next hour.',
      base: 'This is the fragrance you would actually live with: ' + (base || 'the base notes') + '. It can last many hours on skin. If you love this stage, you will love the bottle.'
    };
    document.getElementById('rdl-shelf-stage').textContent = names[ph];
    document.getElementById('rdl-shelf-now').textContent = texts[ph];
    document.querySelectorAll('.rdl-shelf__phases div').forEach(function (d) { d.classList.toggle('is-on', d.dataset.phase === ph); });
  }
  function begin() {
    document.getElementById('rdl-shelf-timer').hidden = false;
    document.getElementById('rdl-shelf-start').textContent = 'Sprayed — timer running';
    render(); clearInterval(iv); iv = setInterval(render, 1000);
  }
  if (start) begin();
  document.getElementById('rdl-shelf-start').addEventListener('click', function () {
    start = Date.now(); try { sessionStorage.setItem(key, String(start)); } catch (e) {}
    track('qr_spray'); begin();
  });

  // rating
  document.querySelectorAll('.rdl-shelf__rate button').forEach(function (b) {
    b.addEventListener('click', function () {
      document.querySelectorAll('.rdl-shelf__rate button').forEach(function (x) { x.classList.remove('is-on'); });
      b.classList.add('is-on'); track('qr_rate', b.dataset.rate);
      document.getElementById('rdl-shelf-rate-msg').textContent = b.dataset.rate === 'love' ? 'Noted. Sign in below and it goes on your scent profile — the finder will use it.' : b.dataset.rate === 'like' ? 'Noted — worth a second smell after the drydown.' : 'Fair. Try "Smell next" below for a different direction.';
    });
  });

  // share to self
  document.getElementById('rdl-shelf-share').addEventListener('click', function () {
    var text = title + ' — top: ' + (top || '–') + ' / heart: ' + (heart || '–') + ' / base: ' + (base || '–') + '. Tried at the Redolia scent bar, Somerville NJ.';
    track('qr_share');
    if (navigator.share) { navigator.share({ title: title, text: text, url: url + '?utm_source=boutique&utm_medium=qr' }).catch(function () {}); }
    else { navigator.clipboard && navigator.clipboard.writeText(text + ' ' + url); document.getElementById('rdl-shelf-email-msg').textContent = 'Copied to your clipboard.'; }
  });

  // email capture
  document.getElementById('rdl-shelf-email').addEventListener('submit', function (ev) {
    ev.preventDefault();
    var email = ev.target.querySelector('input[type=email]').value.trim(); var fn = ev.target.querySelector('[name=first_name]').value.trim(), ln = ev.target.querySelector('[name=last_name]').value.trim();
    var msg = document.getElementById('rdl-shelf-email-msg');
    msg.textContent = 'Saving…';
    fetch(API + '/save-email', { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify({ email: email, first_name: fn, last_name: ln, q: 'SCENT BAR visit — smelled ' + title, picks: [handle] }) })
      .then(function (r) { return r.json(); })
      .then(function (r) { msg.textContent = r.error ? r.error : 'Saved — we will send you the details of ' + title + ' and keep it on your profile.'; track('qr_email'); })
      .catch(function () { msg.textContent = 'Could not save right now — ask us at the counter.'; });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
